import React, { Component } from "react";

class TextArea extends Component {
  constructor(props) {
    super(props);
    this.state = { text: this.props.defaultText };
  }

  render() {
    const maxRows = this.props.maxRows || 5;
    return (
      <div>
        <textarea
          className="text-view p-3 col-md-12" 
          rows={`${maxRows}`}
          onChange={ (event) => { this.onTextChange(event.target.value) } }
          value={ this.state.text } 
          placeholder={ this.props.placeholder } />
      </div>
    )
  }

  onTextChange(text) {
    this.setState({ text });
    this.props.onTextChange(text);
  }
}

export default TextArea;